<!-- Header -->
<app-header></app-header>

<!-- Menu float bar -->
<ng-container *ngIf="data$ | async as data">
  <ng-container *ngIf="isFloatMenu$ | async; else anchoredTemplate">
    <app-menu-float-bar [data]="data"></app-menu-float-bar>
  </ng-container>
  <ng-template #anchoredTemplate>
    <app-menu-bar [data]="data"></app-menu-bar>
  </ng-template>

  <!-- Content -->
  <router-outlet></router-outlet>

  <!-- Whatsapp button -->
  <div *ngIf="data.whatsapp" class="footer__btn-wapp">
    <a (click)="onWhatsLink(data)" target="_blank">
      <img src="/assets/svg/icone-whatsapp.svg" />
    </a>
  </div>

  <!-- Action back to top -->
  <div class="footer__back-to-top" [ngClass]="{ 'footer__back-to-top--hidden': isScrollTop }" (click)="onBackToTop()">
    <svg
      enable-background="new 0 0 551.13 551.13"
      viewBox="0 0 551.13 551.13"
      xmlns="http://www.w3.org/2000/svg"
      id="svg-1d98"
    >
      <path d="m275.565 189.451 223.897 223.897h51.668l-275.565-275.565-275.565 275.565h51.668z"></path>
    </svg>
  </div>
</ng-container>

<!-- Footer -->
<app-footer></app-footer>
